import React, { useContext } from 'react';
import { Dropdown } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLayerGroup, faTimes, faChevronDown, faCheck } from '@fortawesome/free-solid-svg-icons';
import AppContext from 'context/Context';

const SUPPORT_LEVEL_OPTIONS = [
  { value: '0', label: 'Sin nivel asignado' },
  { value: '1', label: 'Nivel 1 Básico' },
  { value: '2', label: 'Nivel 2 Avanzado' },
  { value: '3', label: 'Nivel 3 Desarrollo' },
  { value: '4', label: 'Nivel 4 Externo' },
  { value: '5', label: 'Nivel 5 Cotización' },
  { value: '6', label: 'Nivel 6 Ventas' }
];

const NivelFilterSelect = ({
  selectedNivelId,
  onSelectNivel,
  variant = 'default',
  className = '',
  hideIcon = false,
  showIcon = true
}) => {
  const { config: { isDark } = {} } = useContext(AppContext);
  const isSelected = selectedNivelId !== '' && selectedNivelId !== null && selectedNivelId !== undefined;

  if (variant === 'chip') {
    const selectedOption = SUPPORT_LEVEL_OPTIONS.find(opt => String(opt.value) === String(selectedNivelId));
    const labelText = isSelected && selectedOption ? selectedOption.label : 'Todos los niveles';
    const isFullWidth = className && className.includes('w-100');

    return (
      <Dropdown className={`flex-shrink-0 ${className ? className : 'd-inline-block'}`}>
        <Dropdown.Toggle
          as="div"
          role="button"
          tabIndex={0}
          className={`d-inline-flex align-items-center gap-1.5 px-3 py-1 rounded-pill shadow-none dropdown-caret-none ${isFullWidth ? 'w-100 justify-content-between' : ''}`}
          style={{
            cursor: 'pointer',
            minWidth: 0,
            backgroundColor: isSelected
              ? (isDark ? 'rgba(59, 130, 246, 0.15)' : '#eff6ff')
              : (isDark ? '#1e293b' : '#ffffff'),
            color: isSelected
              ? (isDark ? '#60a5fa' : '#2563eb')
              : (isDark ? '#cbd5e1' : '#334155'),
            border: isSelected
              ? (isDark ? '1px solid rgba(59, 130, 246, 0.35)' : '1px solid #bfdbfe')
              : (isDark ? '1px solid #334155' : '1px solid #e2e8f0'),
            fontSize: '0.80rem',
            fontWeight: 500,
            whiteSpace: 'nowrap'
          }}
        >
          <div className="d-flex align-items-center gap-1.5 overflow-hidden flex-grow-1 min-w-0 me-1" style={{ minWidth: 0 }}>
            {showIcon && !hideIcon && (
              <FontAwesomeIcon
                icon={faLayerGroup}
                className="flex-shrink-0"
                style={{ fontSize: '0.72rem', color: isSelected ? (isDark ? '#60a5fa' : '#2563eb') : '#f59e0b' }}
              />
            )}
            <span className="text-truncate">
              {labelText}
            </span>
          </div>

          <div className="d-flex align-items-center flex-shrink-0 ms-auto">
            {isSelected && (
              <span
                role="button"
                tabIndex={0}
                onClick={e => {
                  e.stopPropagation();
                  onSelectNivel('');
                }}
                className="me-1 d-inline-flex align-items-center justify-content-center"
                style={{
                  width: '16px',
                  height: '16px',
                  borderRadius: '50%',
                  cursor: 'pointer'
                }}
                title="Quitar filtro de nivel"
              >
                <FontAwesomeIcon icon={faTimes} style={{ fontSize: '0.68rem' }} />
              </span>
            )}
            <FontAwesomeIcon icon={faChevronDown} style={{ fontSize: '0.65rem', opacity: 0.7 }} />
          </div>
        </Dropdown.Toggle>

        <Dropdown.Menu
          className={`shadow-lg border py-1 ${isDark ? 'bg-dark' : 'bg-white'}`}
          style={{
            minWidth: '200px',
            maxHeight: '300px',
            overflowY: 'auto',
            zIndex: 1050,
            borderColor: isDark ? '#334155' : '#e2e8f0'
          }}
        >
          <Dropdown.Item
            as="button"
            type="button"
            className={`se-agent-dropdown-item ${!isSelected ? 'se-item-selected-blue' : ''}`}
            onClick={() => onSelectNivel('')}
          >
            <div className="d-flex align-items-center gap-3 overflow-hidden flex-grow-1">
              <FontAwesomeIcon icon={faLayerGroup} className="flex-shrink-0" style={{ width: '16px', color: '#94a3b8' }} />
              <span>Todos los niveles</span>
            </div>
            {!isSelected && <FontAwesomeIcon icon={faCheck} className="ms-auto" />}
          </Dropdown.Item>

          {SUPPORT_LEVEL_OPTIONS.map(opt => {
            const isOptSelected = String(selectedNivelId) === String(opt.value);
            return (
              <Dropdown.Item
                key={opt.value}
                as="button"
                type="button"
                className={`se-agent-dropdown-item ${isOptSelected ? 'se-item-selected-blue' : ''}`}
                onClick={() => onSelectNivel(opt.value)}
              >
                <div className="d-flex align-items-center gap-2 overflow-hidden flex-grow-1">
                  <FontAwesomeIcon icon={faLayerGroup} className="flex-shrink-0" style={{ width: '16px', color: '#3b82f6' }} />
                  <span className="text-truncate">{opt.label}</span>
                </div>
                {isOptSelected && <FontAwesomeIcon icon={faCheck} className="ms-auto" />}
              </Dropdown.Item>
            );
          })}
        </Dropdown.Menu>
      </Dropdown>
    );
  }

  return (
    <div className="d-flex align-items-center gap-2 se-nivel-filter-container position-relative">
      <label
        htmlFor="tickets-nivel-filter-select"
        className="d-flex align-items-center gap-1 text-600 mb-0 fw-semibold"
        style={{ fontSize: '0.80rem', whiteSpace: 'nowrap' }}
      >
        <FontAwesomeIcon
          icon={faLayerGroup}
          style={{ color: isSelected ? (isDark ? '#60a5fa' : '#2563eb') : (isDark ? '#94a3b8' : '#64748b') }}
        />
        <span>Nivel:</span>
      </label>

      <div className="position-relative d-inline-flex align-items-center">
        <select
          id="tickets-nivel-filter-select"
          className="form-select form-select-sm border shadow-none text-900 fw-semibold"
          style={{
            fontSize: '0.82rem',
            borderRadius: '8px',
            cursor: 'pointer',
            backgroundColor: isDark ? '#1e293b' : '#f8fafc',
            borderColor: isSelected ? (isDark ? '#2563eb' : '#60a5fa') : (isDark ? '#233142' : '#e2e8f0'),
            color: isDark ? '#f8fafc' : '#334155',
            paddingRight: isSelected ? '32px' : undefined,
            minWidth: '145px',
            maxWidth: '185px'
          }}
          value={selectedNivelId !== null && selectedNivelId !== undefined ? String(selectedNivelId) : ''}
          onChange={e => onSelectNivel(e.target.value)}
          title="Filtrar tickets por nivel de soporte"
        >
          <option value="">Todos los niveles</option>
          {SUPPORT_LEVEL_OPTIONS.map(opt => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>

        {isSelected && (
          <button
            type="button"
            className="btn btn-link position-absolute p-0 text-muted border-0 shadow-none"
            style={{
              right: '24px',
              top: '50%',
              transform: 'translateY(-50%)',
              fontSize: '0.70rem',
              lineHeight: 1
            }}
            onClick={() => onSelectNivel('')}
            title="Quitar filtro de nivel"
          >
            <FontAwesomeIcon icon={faTimes} />
          </button>
        )}
      </div>
    </div>
  );
};

export default NivelFilterSelect;
